/**
 * Remark plugin that uses micromark-extension-math-extended
 * instead of the default micromark-extension-math.
 *
 * This adds support for LaTeX-style \(...\) and \[...\] delimiters
 * alongside the standard $...$ and $$...$$ delimiters.
 */
/// <reference types="mdast-util-math" />

import { math } from 'micromark-extension-math-extended';
import { mathFromMarkdown } from 'mdast-util-math';

export default function remarkMathExtended(this: any) {

  const data = this.data();

  const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
  const fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);

  micromarkExtensions.push(math());
  fromMarkdownExtensions.push(mathFromMarkdown());
}
